import Header from "./js/header";
import { getHeaderColumn as getHeaderColumnSrc } from "./js/controller";
export var getHeaderColumn = getHeaderColumnSrc;
export default Header;
